module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Flashlight-79d641b1729f9903baac684697e284aa.svg";